export const constructStrRep = (obj) => {
  return obj.str_representation || obj.title || "Vakansbokningsinställning";
};

export const detailUrl = ({ id }) => {
  return `/configcenter/rental-notifications/vacancy-booking-setting/${id}`;
};
